export default __webpack_public_path__ + "static/media/mute.96f89acf.svg";